import { Box } from '@mui/material';
import { getSeriesLabel } from '../../../graph/chart-tooltip-utils';
import { TooltipData } from '../../../graph/types';
import { YoutubeStatsTooltipSeriesHeader } from './YoutubeStatsTooltipSeriesHeader';
import { YoutubeStatsTooltipSeriesValue } from './YoutubeStatsTooltipSeriesValue';
import { YoutubeStatsTooltipTimestamp } from './YoutubeStatsTooltipTimestamp';

type YoutubeStatsMultiTooltipProps = {
  data: TooltipData;
  seriesChannelIds: string[];
  channelMetaById: Record<string, { thumbnailUrl?: string }>;
};

/**
 * Multi-series tooltip for YouTube stats that shows channel logo, label, and value per row.
 */
export function YoutubeStatsMultiTooltip(props: YoutubeStatsMultiTooltipProps) {
  const { data, seriesChannelIds, channelMetaById } = props;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Box sx={{ mb: 0.5 }}>
        <YoutubeStatsTooltipTimestamp timestamp={data.timestamp} />
      </Box>
      {data.series.map((series, index) => {
        const label = getSeriesLabel(series.label);
        const color = typeof series.color === 'string' ? series.color : '#000';
        const channelId = seriesChannelIds[series.uPlotSeriesIndex - 1];
        const thumbnailUrl = channelId ? channelMetaById[channelId]?.thumbnailUrl : undefined;

        return (
          <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
            <Box sx={{ flex: 1 }}>
              <YoutubeStatsTooltipSeriesHeader
                label={label}
                color={color}
                channelThumbnailUrl={thumbnailUrl}
                ribbonHeight={16}
                avatarSize={16}
              />
            </Box>
            <YoutubeStatsTooltipSeriesValue value={series.value} variant="caption" />
          </Box>
        );
      })}
    </Box>
  );
}
